ko.bindingHandlers.enterkey = {
    init: function (element, valueAccessor, allBindings, viewModel) {
        var callback = valueAccessor();
        $(element).keypress(function (event) {
            var keyCode = (event.which ? event.which : event.keyCode);
            if (keyCode === 13) {
                callback.call(viewModel, event);
                return false;
            }
            return true;
        });
    }
};

ko.bindingHandlers.date = {
    init: function (element, valueAccessor, allBindingsAccessor) {
        var underlyingObservable = valueAccessor();

        var interceptor = ko.computed({
            read: function () {
                return global.formatDate(underlyingObservable(), "DD/MM/YYYY", "DD/MM/YYYY");
            },

            write: function (newValue) {
                var current = underlyingObservable();

                if (newValue !== current) {
                    underlyingObservable(newValue);
                    underlyingObservable.valueHasMutated();
                }
            }
        });

        ko.applyBindingsToNode(element, { value: interceptor, valueUpdate: "keyup" });
    }
};



ko.bindingHandlers.number = {
    init: function (element, valueAccessor, allBindingsAccessor) {
        var underlyingObservable = valueAccessor();
        var precision = allBindingsAccessor().precision || 2;

        var interceptor = ko.computed({
            read: function () {
                var value = $.isFunction(underlyingObservable) ? underlyingObservable() : underlyingObservable;
                return global.formatNumber(value, precision);
            },
            write: function (newValue) {
                underlyingObservable(global.formatNumber(newValue, precision));
                underlyingObservable.valueHasMutated();
            }

        });

        ko.applyBindingsToNode(element, { value: interceptor, valueUpdate: "change" });
        global.applyNumericMask({ element: element });

        $(element).on("change focusout",
            $.proxy(function (observable) {

                if (global.unformatNumber(observable()) != global.unformatNumber($(this).val())) {
                    observable($(this).val());
                }
            },
                element,
                underlyingObservable));
    },

    update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        var underlyingObservable = valueAccessor();
        var precision = allBindings().precision || 2;
        $(element).val(global.formatNumber(underlyingObservable(), precision));
    }
}